import { Grid, styled } from "@mui/material";

import Select from "components/Select";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

function BasketSelect() {
  const { setValue, watch } = useFormContext();
  const basketId = watch("basketId");

  const tradeInsertForm = useSelector(
    (state) => state.trade?.tradeInsertForm?.data
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const setDefaultValueForBrokers = (selectedBasket) => {
    const brokers = tradeInsertForm?.lisBroker.filter(
      (item) => +item.basketId === selectedBasket
    );

    const defaultBroker = brokers?.[0]?.brokerId

    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, brokerId: defaultBroker, basketId: selectedBasket });

    setValue("brokerId", defaultBroker);
  }

  const handleChange = (e) => {
    const val = e?.target?.value;

    setValue("basketId", val);
    setValue("price", '');
    setValue("amount", '');

    setDefaultValueForBrokers(val)
  };

  return (
    <Grid container mb={1}>
      <Grid item xs={12}>
        <SelectStyle
          items={tradeInsertForm?.lisBasket}
          itemValue="id"
          itemText="name"
          justifyContent="center"
          value={basketId}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
}

const SelectStyle = styled(Select)(({ theme }) => ({
  textAlign: "center",
  ".MuiSelect-select": {
    padding: theme.spacing(0.5, 2.5),
    fontSize: "12px",
  },
}));

export default BasketSelect;
